import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
const SECRET_KEY: any = 'STLw7oTB61us';
import SecureStorage from 'secure-web-storage';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: "root"
})
export class ServiceLocalStorage {
  private permissionSubj = new Subject();
  PERMISSION_OBJECT = "permission-object";
  permissionobject: any = {};

  AUTH_TOKEN = "auth-token";
  authToken: any = undefined;
  headerContainer: any;

  LOCATION_ID = "location-id";
  locationid!: any;

  SITE_ID = "site-id";
  siteid!: any;

  USER_ID = "user-id";
  userid!: any;

  COMPANY_ID = "company-id";
  companyid!: any;

  MAP_TYPE = "map-type";
  maptype: string;

  COMPANY_WeeklyOff = "company-weeklyoff";
  companyweeklyoff: string;

  _mRouteName = "route-name";
  routeName: string;

  _mSubRouteName = "sub-route-name";
  subRouteName: string;

  constructor() { }

  public displayNameOnTop: BehaviorSubject<any> = new BehaviorSubject('');

  setFirstNameObs(nameDisplay: any) {
    this.displayNameOnTop.next(nameDisplay);
  }

  getFirstNameObs(): Observable<any> {
    return this.displayNameOnTop.asObservable();
  }

  setHeaderContainer(container: any) {
    this.headerContainer = container;
  }

  setAuthToken(token: string) {
    localStorage.setItem(this.AUTH_TOKEN, token);
    this.authToken = token;
  }

  getAuthToken(): string {
    if (this.authToken == undefined || this.authToken == null) {
      this.authToken = localStorage.getItem(this.AUTH_TOKEN);
    }
    return this.authToken;
  }

  setMapType(mapType: string) {
    localStorage.setItem(this.MAP_TYPE, mapType);
    this.maptype = mapType;
  }

  getMapType(): string {
    if (this.maptype == undefined || this.maptype == null) {
      this.maptype = localStorage.getItem(this.MAP_TYPE);
    }
    return this.maptype;
  }

  hasAuthToken(): boolean {
    if (this.authToken == undefined || this.authToken == null) {
      this.authToken = localStorage.getItem(this.AUTH_TOKEN);
    }
    return this.authToken !== undefined && this.authToken !== null && this.authToken.length > 0 ? true : false;
  }

  deleteAll(): void {
    this.authToken = undefined;
    localStorage.clear();
  }

  setLocationId(locationid: string) {
    localStorage.setItem(this.LOCATION_ID, locationid);
    this.locationid = locationid;
  }

  getLocationId(): string {
    if (this.locationid == undefined || this.locationid == null) {
      this.locationid = localStorage.getItem(this.LOCATION_ID);
    }
    return this.locationid;
  }

  setSiteId(siteid: string) {
    localStorage.setItem(this.SITE_ID, siteid);
    this.siteid = siteid;
  }

  getSiteId(): string {
    if (this.siteid == undefined || this.siteid == null) {
      this.siteid = localStorage.getItem(this.SITE_ID);
    }
    return this.siteid;
  }

  public secureStorage = new SecureStorage(localStorage, {
    hash: function hash(key: any): any {
      key = CryptoJS.SHA256(key, SECRET_KEY);
      return key.toString();
    },
    // Encrypt the localstorage data
    encrypt: function encrypt(data: any) {
      data = CryptoJS.AES.encrypt(data, SECRET_KEY);
      data = data.toString();
      return data;
    },
    // Decrypt the encrypted data
    decrypt: function decrypt(data: any) {
      data = CryptoJS.AES.decrypt(data, SECRET_KEY);
      data = data.toString(CryptoJS.enc.Utf8);
      return data;
    }
  });

  // Set the json data to local storage
  setJsonValue(key: string, value: any) {
    this.secureStorage.setItem(key, value);
  }

  // Get the json value from local storage
  getJsonValue(key: string) {
    return this.secureStorage.getItem(key);
  }

  // Clear the local storage
  clearToken() {
    return this.secureStorage.clear();
  }

  setUserId(userid: string): void {
    localStorage.setItem(this.USER_ID, userid);
    this.userid = userid;
  }

  getUserId(): string {
    if (this.userid == undefined || this.userid == null) {
      this.userid = localStorage.getItem(this.USER_ID);
    }
    return this.userid;
  }

  setCompanyId(companyid: string) {
    localStorage.setItem(this.COMPANY_ID, companyid);
    this.companyid = companyid;
  }

  getCompanyId(): string {
    if (this.companyid == undefined || this.companyid == null) {
      this.companyid = localStorage.getItem(this.COMPANY_ID);
    }
    return this.companyid;
  }

  setSelectedFloorPlan(selectedFloorPLan: any) {
    if (this.headerContainer != null) {
      this.headerContainer.selectedFloorPlan = selectedFloorPLan;
    }
  }

  setSelectedParkingFloorPlan(selectedParkingFloorPLan: any) {
    if (this.headerContainer != null) {
      this.headerContainer.selectedFloorPlan = selectedParkingFloorPLan;
    }
  }
  
  setcompanyWeeklyOff(companyweeklyoff: string) {
    localStorage.setItem(this.COMPANY_WeeklyOff, companyweeklyoff);
    this.companyweeklyoff = companyweeklyoff;
  }

  getCompanyWeeklyOff(): string {
    if (this.companyweeklyoff == undefined || this.companyweeklyoff == null) {
      this.companyweeklyoff = localStorage.getItem(this.COMPANY_WeeklyOff);
    }
    return this.companyweeklyoff;
  }
  
  getPermissionObject(): any {
    if (this.permissionobject == undefined || this.permissionobject == null) {
      this.permissionobject = localStorage.getItem(this.PERMISSION_OBJECT);
    }
    this.permissionSubj.next(this.permissionobject);
    return this.permissionobject;
  }

  setPermissionObject(permissionobject: any) {
    localStorage.setItem(this.PERMISSION_OBJECT, permissionobject);
    this.permissionobject = permissionobject;
    this.permissionSubj.next(permissionobject);
  }

  setRouteName(routeName: string) {
    localStorage.setItem(this._mRouteName, routeName);
    this.routeName = routeName;
  }

  getRouteName(): string {
    if (this.routeName == undefined || this.routeName == null) {
      this.routeName = localStorage.getItem(this._mRouteName);
    }
    return this.routeName;
  }

  setSubRouteName(subRouteName: string) {
    localStorage.setItem(this._mSubRouteName, subRouteName);
    this.subRouteName = subRouteName;
  }

  getSubRouteName(): string {
    if (this.subRouteName == undefined || this.subRouteName == null) {
      this.subRouteName = localStorage.getItem(this._mSubRouteName);
    }
    return this.subRouteName;
  }

}
